import { lazy, Suspense } from 'react';
import { Spin } from 'antd';

// Excalidraw весит около мегабайта — грузим его, только когда открыли вкладку.
const WhiteboardCanvas = lazy(() => import('./WhiteboardCanvas.tsx'));

interface ItemWhiteboardProps {
  spaceId: string;
  spaceSlug?: string;
  itemId: string;
  canEdit: boolean;
  /** Связанная задача Jira, если интеграция включена. */
  jiraIssueKey?: string | null;
}

export function ItemWhiteboard(props: ItemWhiteboardProps): JSX.Element {
  return (
    <Suspense
      fallback={
        <div style={{ display: 'flex', justifyContent: 'center', padding: 48 }}>
          <Spin />
        </div>
      }
    >
      <WhiteboardCanvas key={props.itemId} {...props} />
    </Suspense>
  );
}
